import { Injectable } from '@angular/core';
import { PaymentTermService } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import { OneClickOrdersActionTypes, OneClickSelectOrderAction } from '../actions/one-click-orders.actions';
import {
  OneClickLoadPaymentsAction,
  OneClickLoadPaymentsCompleteAction,
  OneClickPaymentsActionTypes,
  OneClickResetPaymentsAction,
} from '../actions/one-click-payments.actions';
import { State } from '../reducers';

/**
 * TODO: Check this class, is it being used?
 */
@Injectable()
export class OneClickPaymentsEffects {
  loadPaymentsCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        this.store.dispatch(new OneClickResetPaymentsAction());
        return new OneClickLoadPaymentsAction(action.payload);
      }),
    ),
  );

  paymentTermsLoadFromProduct = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickPaymentsActionTypes.LOAD_PAYMENTS),
      map((action: OneClickLoadPaymentsAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) => {
        return this.paymentTermsService
          .getCustomerPaymentTermsV2({
            countryCode: order.customer.countryCode,
            productLineId: order.items[0].product.productType.productTypeId,
            jobsiteId: order.jobsite.jobsiteId,
            customerId: order.customer.customerId,
            productId: order.items[0].product.productId,
          })
          .pipe(
            map((response: any) => {
              return new OneClickLoadPaymentsCompleteAction(response.paymentTerms, 0);
            }),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private paymentTermsService: PaymentTermService,
  ) {}
}
